/**
 * English function words — the words that carry grammar rather than topic.
 *
 * Used where a tool ranks words by how much they say about a text (summary keywords,
 * concordance collocates): without this list "the", "of" and "and" win every ranking.
 * Contractions are listed without the apostrophe because callers strip it first.
 */
export const STOPWORDS: ReadonlySet<string> = new Set([
  "a",
  "about",
  "above",
  "after",
  "again",
  "against",
  "all",
  "also",
  "am",
  "among",
  "an",
  "and",
  "any",
  "are",
  "as",
  "at",
  "be",
  "because",
  "been",
  "before",
  "being",
  "below",
  "between",
  "both",
  "but",
  "by",
  "can",
  "cannot",
  "could",
  "did",
  "do",
  "does",
  "doing",
  "down",
  "during",
  "each",
  "either",
  "et",
  "al",
  "etc",
  "even",
  "ever",
  "every",
  "few",
  "for",
  "from",
  "further",
  "had",
  "has",
  "have",
  "having",
  "he",
  "her",
  "here",
  "hers",
  "herself",
  "him",
  "himself",
  "his",
  "how",
  "however",
  "i",
  "if",
  "in",
  "into",
  "is",
  "it",
  "its",
  "itself",
  "just",
  "less",
  "may",
  "me",
  "might",
  "more",
  "most",
  "much",
  "must",
  "my",
  "myself",
  "neither",
  "no",
  "nor",
  "not",
  "now",
  "of",
  "off",
  "often",
  "on",
  "once",
  "one",
  "only",
  "or",
  "other",
  "others",
  "our",
  "ours",
  "ourselves",
  "out",
  "over",
  "own",
  "per",
  "rather",
  "same",
  "shall",
  "she",
  "should",
  "since",
  "so",
  "some",
  "such",
  "than",
  "that",
  "the",
  "their",
  "theirs",
  "them",
  "themselves",
  "then",
  "there",
  "therefore",
  "these",
  "they",
  "this",
  "those",
  "though",
  "through",
  "thus",
  "to",
  "too",
  "under",
  "until",
  "up",
  "upon",
  "us",
  "very",
  "via",
  "was",
  "we",
  "were",
  "what",
  "when",
  "where",
  "whether",
  "which",
  "while",
  "who",
  "whom",
  "whose",
  "why",
  "will",
  "with",
  "within",
  "without",
  "would",
  "yet",
  "you",
  "your",
  "yours",
  "yourself",
  "dont",
  "doesnt",
  "didnt",
  "isnt",
  "arent",
  "wasnt",
  "werent",
  "cant",
  "couldnt",
  "wouldnt",
  "shouldnt",
  "wont",
  "thats",
  "theres",
  "theyre",
  "youre",
  "ive",
  "id",
  "ill",
  "im",
]);
